import { Component, OnInit } from "@angular/core";
import { LoginService } from "../../services/login/login.service";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  hide = true;
  user: string;
  pass: string;
  usuarioId: number;
  name: string;
  lastname: string;
  status: string;
  functions: string[];
  rol: string;

  constructor(
    public loginservice: LoginService,
    private dialogRef: MatDialogRef<LoginComponent>,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.dialogRef.addPanelClass("loginDialog");
  }

  limpiarLogin(): void {
    this.user = "";
    this.pass = "";
  }

  openSnackBar(message) {
    this._snackBar.open(message, "", {
      duration: 2000,
      horizontalPosition: "center",
      verticalPosition: "top",
    });
  }

  validacion(): void {
    const user = {
      usuario_realgisUsuario: this.user,
      usuario_realgisClave: this.pass,
    };
    this.loginservice.login(user).subscribe((data) => {
      if (data["SDTUsuaroRolFuncion"].length > 0) {
        this.status = data["SDTUsuaroRolFuncion"][0].Estado;
        if (this.status == "Activo") {
        this.name = data["SDTUsuaroRolFuncion"][0].usuario_realgisNombre1;
        this.lastname = data["SDTUsuaroRolFuncion"][0].usuario_realgisApellido1;
        this.usuarioId = data["SDTUsuaroRolFuncion"][0].usuario_realgisId;
        this.loginservice.userId = this.usuarioId;
        this.rol = data["SDTUsuaroRolFuncion"][0].Rol_Nombre;
        var funciones = "";
        funciones = data["SDTUsuaroRolFuncion"][0].Funciones;
        this.functions = funciones.split("*");
        this.loginservice.userName = this.name;
        this.loginservice.userLastname = this.lastname;
        this.loginservice.userRol = this.rol;
        this.loginservice.settings = this.functions.includes("Settings");
        this.loginservice.layers = this.functions.includes("Layers");
        this.loginservice.search = this.functions.includes("Search");
        this.loginservice.createActive = this.functions.includes("Create Active");        
        this.loginservice.views = this.functions.includes("Views");
        this.loginservice.zoom = this.functions.includes("Zoom");
        this.loginservice.mLine = this.functions.includes("Measure Line");
        this.loginservice.mPol = this.functions.includes("Measure Polygon");
          this.openSnackBar(
            "Ingreso Correcto: " + this.name + " " + this.lastname
          );
          this.dialogRef.close();
        }else{
          this.openSnackBar(
            "Usuario " + this.status
          );
        }
      } else {
        this.openSnackBar("Datos de ingreso incorrectos");
        this.limpiarLogin();
      }
    });
  }
}
